module.exports = __webpack_public_path__ + "img/9.5794902a.png";